// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KreY","toggle":"styles_toggle__3_tt3","preview":"styles_preview__LxAdR"};